import { Glyph } from "./glyphs";

const LINE_GAP = 10;
const ICON_SIZE = LINE_GAP * 4;

const RHYTHM_GROUPS = {
  eighth_pair: {
    buttonWidth: 58,
    svgWidth: 58,
    transform: "translate(8, 15.5)"
  },

  sixteenth_sixteenth_eighth: {
    buttonWidth: 74,
    svgWidth: 74,
    transform: "translate(10, 15.5)"
  },

  eighth_sixteenth_sixteenth: {
    buttonWidth: 74,
    svgWidth: 74,
    transform: "translate(10, 15.5)"
  },

  sixteenth_four: {
    buttonWidth: 88,
    svgWidth: 88,
    transform: "translate(10, 15.5)"
  },

  "1e1e1e": {
    buttonWidth: 72,
    svgWidth: 72,
    transform: "translate(10, 15.5)"
  },

  "2s1e1e": {
    buttonWidth: 84,
    svgWidth: 84,
    transform: "translate(10, 15.5)"
  },

  "1e2s1e": {
    buttonWidth: 84,
    svgWidth: 84,
    transform: "translate(10, 15.5)"
  },

  "1e1e2s": {
    buttonWidth: 84,
    svgWidth: 84,
    transform: "translate(10, 15.5)"
  },

  "2s2s1e": {
    buttonWidth: 100,
    svgWidth: 100,
    transform: "translate(10, 15.5)"
  },

  "2s1e2s": {
    buttonWidth: 100,
    svgWidth: 100,
    transform: "translate(10, 15.5)"
  },

  "1e2s2s": {
    buttonWidth: 100,
    svgWidth: 100,
    transform: "translate(10, 15.5)"
  },

  "2s2s2s": {
    buttonWidth: 116,
    svgWidth: 116,
    transform: "translate(10, 15.5)"
  }
};

function isWideRhythm(symbol) {
  return !!RHYTHM_GROUPS[symbol];
}

function paletteTransformFor(symbol) {
  if (RHYTHM_GROUPS[symbol]) {
    return RHYTHM_GROUPS[symbol].transform;
  }

  if (symbol === "whole_note") {
    return "translate(-8, 15.5)";
  }

  if (symbol.endsWith("_note")) {
    return "translate(-7, 15.5)";
  }

  if (symbol === "whole_rest") {
    return "translate(-7, 0)";
  }

  if (symbol === "half_rest") {
    return "translate(-7, 5)";
  }

  return "translate(-3, 2)";
}

function viewBoxFor(symbol) {
  if (isWideRhythm(symbol)) {
    const w = RHYTHM_GROUPS[symbol].svgWidth;
    return `0 -28 ${w} 56`;
  }

  return "-24 -24 48 48";
}

export default function SymbolPalette({
  allowedSymbols,
  selected,
  onSelect,
  disabled = false
}) {
  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        marginBottom: "12px",
        alignItems: "center",
        flexWrap: "wrap"
      }}
    >
      {allowedSymbols.map((sym) => {
        const rhythmGroup = RHYTHM_GROUPS[sym];

        const buttonWidth =
          rhythmGroup?.buttonWidth ?? ICON_SIZE + 12;

        const svgWidth =
          rhythmGroup?.svgWidth ?? ICON_SIZE;

        return (
          <button
            key={sym}
            type="button"
            disabled={disabled}
            onClick={() => onSelect(sym)}
            style={{
              width: buttonWidth,
              height: ICON_SIZE + 12,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "white",
              border:
                sym === selected
                  ? "2px solid #1976d2"
                  : "1px solid #ccc",
              borderRadius: "4px",
              cursor: disabled ? "default" : "pointer",
              padding: 0,
              opacity: disabled ? 0.55 : 1
            }}
            title={sym.replaceAll("_", " ")}
          >
            <svg
              width={svgWidth}
              height={ICON_SIZE}
              viewBox={viewBoxFor(sym)}
              style={{ overflow: "visible" }}
            >
              <g transform={paletteTransformFor(sym)}>
                {sym.endsWith("_rest") && <RestAnchor symbol={sym} />}
                <Glyph symbol={sym} />
              </g>
            </svg>
          </button>
        );
      })}
    </div>
  );
}

function RestAnchor({ symbol }) {
  if (symbol === "half_rest") {
    return (
      <line
        x1={-6}
        x2={19}
        y1={0}
        y2={0}
        stroke="#000"
        strokeWidth={1.2}
      />
    );
  }

  if (symbol === "whole_rest") {
    return (
      <line
        x1={-6}
        x2={19}
        y1={0}
        y2={0}
        stroke="#000"
        strokeWidth={1.2}
      />
    );
  }

  return null;
}